import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { IonButton, IonIcon, IonContent } from '@ionic/react';
import { chevronBackOutline, chevronForwardOutline } from 'ionicons/icons';
import { Map, GoogleApiWrapper, Marker } from '../googleMapsReact';
import { getConfig } from '../../appConfig.js';
import { withTranslation } from '../../lib/translate';
import { isDefined, emptyString } from '../../lib/utils';
import Pullup from '../pullup';
import { Title, NormalText, StrongText, Subtitle, Spacer } from '../common';
import Loading from '../spinner';
import './index.css';
import { getRestaurants } from '../../store/actions';
import Slider, { Slide } from '../slider';

const embedLocationInMapLayer = false;

export class MapContainer extends Component {
  constructor(props) {
    super(props);

    this.sliderRef = React.createRef();
    this.state = {
      stores: [],
      map: null,
      locationId: null,
      locationHolderNested: false,
      slideInit: false,
      initialLatCenter: getConfig().services.google_maps.defaultLat,
      initialLngCenter: getConfig().services.google_maps.defaultLng,
      initialZoom: 18,
    };
  }
  setStoresState = () => {
    let locations = [];
    this.props.restaurants.forEach((restaurant) => {
      if (
        restaurant &&
        restaurant.is_published &&
        restaurant.position &&
        restaurant.position !== null
      ) {
        const position = this.parseLocation(restaurant.position);
        locations.push({
          latitude: position.lat,
          longitude: position.lng,
          ...restaurant,
        });
      }
    });
    if (locations.length > 0) {
      const locationId = locations[0].id;
      this.setState({
        stores: locations,
        locationId,
        initialLatCenter: locations[0].latitude,
        initialLngCenter: locations[0].longitude,
      });
    }
  };

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getRestaurants());
    this.setStoresState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.restaurants.length !== this.props.restaurants.length) {
      this.setStoresState();
    }
    if (
      this.props.restaurants &&
      this.props.restaurants.length > 0 &&
      prevProps.restaurants &&
      prevProps.restaurants.length > 0 &&
      prevProps.restaurants[0].distance &&
      this.props.restaurants[0].distance &&
      prevProps.restaurants[0].distance !== this.props.restaurants[0].distance
    ) {
      this.setStoresState();
    }
  }

  onMapReady = (mapProps, map) => {
    this.setState({ map });
  };

  displayMarkers = () => {
    return (this.state.stores || {}).map((store, index) => {
      return (
        <Marker
          key={index}
          id={store.id}
          position={{
            lat: store.latitude,
            lng: store.longitude,
          }}
          zIndex={store.id === this.state.locationId ? 10 : 0}
          onClick={this.onMarkerClick}
          name={store.name}
        />
      );
    });
  };

  onMarkerClick = (props, marker) => {
    let slide = null;
    const store = this.state.stores.find((s, index) => {
    if(s.id === props.id){
      slide = index;
      return true;
    }});
    this.setState(
      {
        activeMarker: marker,
        locationId: props.id,
        slideInit: false,
      },
      () => this.changeSlide(null, slide, store, false),
    );
  };

  changeSlideArrow = (direction = 'next') => {
    if ((this.state.stores || []).length <= 1) {
      return;
    }
    this.setState({ slideChangedUsingArrows: true }, () => {
      if (direction === 'next') {
        this.state.swiper.slideNext();
      }
      if (direction === 'prev') {
        this.state.swiper.slidePrev();
      }
    });
  };

  changeSlide = (direction = 'next', slide = null, store, useCbEvents = true) => {
    if ((this.state.stores || []).length <= 1) {
      return;
    }
    if (direction === 'next') {
      this.state.swiper.slideNext(100, useCbEvents);
      this.changeMarker('next');
    }
    if (direction === 'prev') {
      this.state.swiper.slidePrev(100, useCbEvents);
      this.changeMarker('next');
    }
    if (isDefined(slide)) {
      this.state.swiper.slideTo(slide, 0, useCbEvents);
      this.setState({ locationId: store.id }, () => {
        this.displayMarkers();
        this.zoomToTheMarker();
      });
    }
  };

  changeMarker = (direction) => {
    const { stores, locationId } = this.state;
    let nextIndex;
    const current = stores.find((s) => s.id === locationId);
    const curentIndex = stores.indexOf(current);
    if (direction === 'next') {
      if (curentIndex === stores.length - 1) {
        nextIndex = 0;
      } else {
        nextIndex = curentIndex + 1;
      }
    } else {
      if (curentIndex === 0) {
        nextIndex = stores.length - 1;
      } else {
        nextIndex = curentIndex - 1;
      }
    }
    const store = stores[nextIndex];
    this.setState({ locationId: store.id }, () => {
      this.displayMarkers();
      this.zoomToTheMarker();
    });
  };
  parseLocation = (location = '') => {
    if (isDefined(location) && location !== '') {
      let position = location.split(',');
      return {
        lat: position[0],
        lng: position[1],
      };
    }

    return {};
  };

  zoomToTheMarker = () => {
    // use initial Lat and Lng for center map
    const { locationId, stores, map } = this.state;
    if (isDefined(locationId) && stores.length > 0) {
      this.setState({ slideChangedUsingArrows: false }, () => {
        const selectedRestaurant = stores.find((s) => s.id === locationId);
        if (
          isDefined(selectedRestaurant) &&
          isDefined(selectedRestaurant.latitude) &&
          isDefined(selectedRestaurant.longitude)
        ) {
          const lat = parseFloat(selectedRestaurant.latitude);
          const lng = parseFloat(selectedRestaurant.longitude);
          const initialZoom = 18;
          this.setState({ initialLatCenter: lat, initialLngCenter: lng, initialZoom }, () => {
            if (lat && lng) {
              map.panTo({ lat, lng });
              map.setZoom(initialZoom);
            }
          });
        }
      });
    }
  };

  nestLocationLayer = () => {
    if (document) {
      const mapTG = document.querySelector('.gm-style');
      if (mapTG) {
        const locationHolder = document.querySelector('.map-location-pullup');
        mapTG.appendChild(locationHolder);
      }
    }
  };

  mapBoundsChanged = () => {
    if (!this.state.locationHolderNested) {
      this.setState({
        locationHolderNested: true,
      });
      this.nestLocationLayer();
    }
  };

  render() {
    const { __ } = this.props;
    const { stores, locationId, initialLatCenter, initialLngCenter, initialZoom } = this.state;
    let selectedRestaurant = null;
    let slideIndex = null;
    if (isDefined(locationId) && stores.length > 0) {
      selectedRestaurant = stores.find((s) => s.id === locationId);
      slideIndex = stores.indexOf(selectedRestaurant);
    }

    let isMonToFriSame = true;
    let ot = null;
    let ct = null;
    if (selectedRestaurant) {
      (selectedRestaurant.json_opening_times || []).forEach((item) => {
        if (['w6', 'w0'].indexOf(item.day_code) !== -1) {
          return;
        }
        if (!ot) {
          ot = item.open_time;
        }
        if (!ct) {
          ct = item.close_time;
        }
        isMonToFriSame = ot === item.open_time && ct === item.close_time && isMonToFriSame;
      });
    }
    let height = '100%';
    let dynamicHeaderHeight = 50;
    if (
      document &&
      document.querySelector('.map-location-pullup') &&
      document.querySelector('.dynamic-header')
    ) {
      dynamicHeaderHeight = document.querySelector('.dynamic-header').clientHeight;
      height =
        document.querySelector('.map-location-pullup').offsetTop !== 0
          ? parseInt(document.querySelector('.map-location-pullup').offsetTop - dynamicHeaderHeight)
          : '100%';
    }

    return (
      <Loading additionalLoadingCondition={!isDefined(stores) || stores.length === 0}>
        <Map
          google={this.props.google}
          zoom={initialZoom}
          className="map"
          initialCenter={{ lat: initialLatCenter, lng: initialLngCenter }}
          streetViewControlOptions={{ position: 7 }}
          zoomControlOptions={{ position: 7 }}
          onBounds_changed={() => (embedLocationInMapLayer ? this.mapBoundsChanged : null)}
          onReady={this.onMapReady}
          style={{ height }}
        >
          {this.displayMarkers()}
        </Map>
        <Pullup
          className="map-location-pullup"
          top={35}
          offsetTop={170}
          offsetBottom={window.innerHeight / 2}
          isMap={true}
        >
          <div className="map-location-holder">
            <div className="map-location-content">
              <div className="map-location-nav" onClick={() => this.changeSlideArrow('prev')}>
                <IonButton size="small" fill="clear">
                  <IonIcon slot="icon-only" color="gray" icon={chevronBackOutline} />
                </IonButton>
              </div>
              <IonContent keyscrollEvents={true}>
              <Slider
                  className={(stores || []).length <= 1 ? 'swiper-no-swiping' : ''}
                  ref={this.sliderRef}
                  settings={{
                    loop: true,
                    initialSlide: slideIndex,
                    onSwiper: (swiper) => {
                      this.setState({swiper})},
                    onSlideNextTransitionEnd: () => {
                      this.setState({ slideChangedUsingArrows: true }, () => {
                        this.changeMarker('next');
                      });  
                    },
                    onSlidePrevTransitionEnd: () => { 
                      this.setState({ slideChangedUsingArrows: true }, () => {
                        this.changeMarker('prev');
                      });
                    }
                  }}
                >
                  {stores.map((store, i) => {
                    return (
                      <Slide key={'slide-' + i}>
                        <div>
                          <Title className="secondary-title">{store.name}</Title>
                        </div>
                        {store.address ? (
                          <div className='locations-box'>
                            <Subtitle className="map-text ">{__('Address')}</Subtitle>
                            <NormalText className="primary-color primary-regular">
                              <u>{store.address || emptyString}</u>
                            </NormalText>
                          </div>
                        ) : null}
                        {store.json_opening_time_info && store.json_opening_time_info.length > 0 ? (
                          <div className='locations-box'>
                            <Subtitle className="map-text ">{__('Opening Hours')}</Subtitle>
                            <div className="location-info">
                              {store.json_opening_time_info.map((item, index) => {
                                return (
                                  <div key={index} className="location-info-segment">
                                    <StrongText className="primary-regular thiner-text">
                                      {item.day}
                                    </StrongText>
                                    <div>
                                      <NormalText className="primary-regular location-time thiner-text">
                                        {__(item.time)}
                                      </NormalText>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        ) : null}
                        {store.food_service_times_json &&
                        store.food_service_times_json.length > 0 ? (
                          <div className='locations-box'>
                            <Subtitle className="map-text ">{__('Food Service Times')}</Subtitle>
                            <div className="location-info">
                              {store.food_service_times_json.map((item, index) => {
                                return (
                                  <>
                                    {index !== 0 && <Spacer size={1} />}
                                    {item.label && <StrongText>{__(item.label)}</StrongText>}
                                    {item.times.map((time, i) => (
                                      <div key={`${index}_${i}`} className="location-info-segment">
                                        <StrongText className="primary-regular thiner-text">
                                          {time.day}
                                        </StrongText>
                                        <div>
                                          {time.time.split(',').map((el, timeIndex) => (
                                            <NormalText className="primary-regular location-time thiner-text">
                                              {__(el)}
                                            </NormalText>
                                          ))}
                                        </div>
                                      </div>
                                    ))}
                                  </>
                                );
                              })}
                            </div>
                          </div>
                        ) : null}
                        {store?.additional_settings?.amenities.length > 0 && (
                          <div className='locations-box'>
                            <Subtitle>{__('Amenities')}</Subtitle>
                            {store?.additional_settings?.amenities.map((item) => (
                              <NormalText className="block">
                                <b>{item.text}:</b> {item.value}
                              </NormalText>
                            ))}
                          </div>
                        )}
                        {store.telephone ? (
                          <div className='locations-box'>
                            <Subtitle className="no-margin map-text ">{__('Telephone')}</Subtitle>
                            <NormalText className="primary-color primary-regular">
                              <a href={`tel:${store.telephone}` || emptyString}>
                                {store.telephone || emptyString}
                              </a>
                            </NormalText>
                          </div>
                        ) : null}
                        {store.email ? (
                          <div className='locations-box'>
                            <Subtitle className="map-text ">{__('Email')}</Subtitle>
                            <NormalText className="primary-regular" color="background">
                              <a href={`mailto:${store.email}` || emptyString}>
                                {store.email || emptyString}
                              </a>
                            </NormalText>
                          </div>
                        ) : null}
                        {store?.additional_settings?.links?.map((link) => (
                          <IonButton
                            expand="block"
                            className="uppercase"
                            color="primary"
                            fill="outline"
                            onClick={() => window.open(link.url)}
                          >
                            {__(link.text)}
                          </IonButton>
                        ))}
                      </Slide>
                    );
                  })}
                </Slider>
              </IonContent>
              <div className="map-location-nav" onClick={() => this.changeSlideArrow('next')}>
                <IonButton size="small" fill="clear">
                  <IonIcon slot="icon-only" color="gray" icon={chevronForwardOutline} />
                </IonButton>
              </div>
            </div>
          </div>
        </Pullup>
      </Loading>
    );
  }
}

const stateToProps = (state) => {
  const { restaurants } = state.restaurants;
  return {
    restaurants: restaurants || [],
  };
};

export default GoogleApiWrapper({
  apiKey: getConfig().services.google_maps.google_api_key,
})(withRouter(withTranslation(connect(stateToProps)(MapContainer))));
